import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const META_PIXEL_ID = '2091189388346525';
function loadMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) {
    w.fbq('track', 'PageView');
    return;
  }
  try {
    ;
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  } catch (err) {
    // Silently fail — pixel should never break the app
    console.error('Meta Pixel load error:', err);
  }
}
function Root() {
  useEffect(() => {
    document.title = 'COSMOS V';
    loadMetaPixel(META_PIXEL_ID);
  }, []);
  return <App data-id="element-186" />;
}
render(<Root data-id="element-187" />, document.getElementById('root'));